import Vue from 'vue'
import VueRouter from 'vue-router'
import publicRoutes from './public_routes';
import adminRoutes from './admin_routes';
import useAuth from '@/useAuth';

const { isAuthenticated, user, userIsAdmin, appInitialized, tryRestore } = useAuth();

Vue.use(VueRouter)


let routes = publicRoutes;
routes = routes.concat(adminRoutes);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },

})

router.beforeEach(async (to, from, next) => {

  if (!appInitialized.value) {
    await tryRestore();
  }

  if (!isAuthenticated.value && to.name !== 'auth-login') {

    next({ name: 'auth-login' });
    return;
  }

  if (to.path.indexOf('/admin') > -1 && !userIsAdmin.value) {
    next({ name: 'home' });
    return;
  }

  if (!!to.meta.tenantAdmin && !user.value.is_tenant_admin) {
    next({ name: 'home' });
    return;
  }

  if (to.meta.extraPermissions) {
    switch (to.meta.extraPermissions) {
      case "feedbackAdmin":
        if (!user.value.is_feedback_manager) {
          next({ name: 'home' });
          return;
        }
      default:
        break;
    }
  }

  next();
})

export default router
